import React from 'react';
import { FormattedMessage } from 'react-intl';

import MarketplaceLogo from '@/pages/Config/common/MarketplaceLogo/MarketplaceLogo';
import {
    StickyContainer,
    TitleContainer,
    PanelTitle,
    PanelSubTitle,
    PanelText,
    ContactButton,
} from './DeliverooPanel.style';

const CONTACT_URL = 'https://share.hsforms.com/1gLM3xDgiRR64afcYf0XI0g3e34n';

const DeliverooPanel: React.FunctionComponent<React.PropsWithChildren> = () => {
    return (
        <div>
            <StickyContainer>
                <TitleContainer>
                    <MarketplaceLogo name="deliveroo" />
                    <PanelTitle text="deliveroo.title" />
                </TitleContainer>

                <PanelSubTitle text="deliveroo.subtitle" weight="bold" />
                <PanelText text="deliveroo.description.firstpart" />

                <PanelText text="deliveroo.description.secondpart" />

                <PanelText text="deliveroo.description.thirdpart" />

                <a href={CONTACT_URL} target="_BLANK" rel="noopener noreferrer">
                    <ContactButton buttonType="outlinedPrimary">
                        <FormattedMessage id="deliveroo.contact" />
                    </ContactButton>
                </a>
            </StickyContainer>
        </div>
    );
};

export default DeliverooPanel;
